var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-capsule-chart',{staticStyle:{"width":"300px","height":"200px"},attrs:{"config":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }